import React from 'react';
import { motion } from 'framer-motion';
import { researchConceptStatus, researchConcepts } from '../../data/siteContent';
import { fadeUp } from '../../utils/motion';

/** Future research: exploratory concepts with one shared status explanation. */
export function ResearchConcepts() {
  return <section id="research-concepts" aria-labelledby="research-concepts-title" className="scroll-mt-20 bg-white border-t border-line py-20 lg:py-24" data-id="element-1868" data-mp="29waov2mwloog">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16" data-id="element-1869" data-mp="2ojvub3793zzj">
        <motion.div {...fadeUp} className="lg:col-span-5" data-id="element-1870" data-mp="2joqbwed253g7">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-1871" data-mp="2xl3q9emaooqg">Future research</p>
          <h2 id="research-concepts-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1872" data-mp="2tkjtwd9jpp5d">
            Research concepts
          </h2>
          <p className="mt-5 text-ink-muted leading-relaxed" data-id="element-1873" data-mp="z725ko1bgo9a">{researchConceptStatus}</p>
        </motion.div>
        <motion.dl {...fadeUp} className="lg:col-span-7 border-t border-line" data-id="element-1874" data-mp="3g32kml0mdcmq">
          {researchConcepts.map(concept => <div key={concept.title} className="border-b border-line py-6" data-id="element-1875" data-mp="3l2f6b2fr8dnq">
              <dt className="font-heading font-bold text-xl text-ink-dark" data-id="element-1876" data-mp="3q0gpdnd6kcz7">{concept.title}</dt>
              <dd className="mt-2 text-lg text-ink-muted leading-relaxed" data-id="element-1877" data-mp="3urqemmutheak">{concept.body}</dd>
            </div>)}
        </motion.dl>
      </div>
    </section>;
}